import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
} from '@mui/material';
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';

import {
  ConfirmationUploadDialog,
  NewDirectPaymentDialog,
} from '../../../../../components/LoansScreen';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../../components/common/Table';
import { Grid, Button, DataLoading } from '../../../../../components/common';
import { directPayment } from '../../../../../utils';
import FarmContext from '../../../../../store/farm-context';
import AccordionFormContext from '../../../../../store/accordion-form-context';
import SimpleFarmSelect from '../../../../../components/FarmSelect/SimpleFarmSelect';

export default function SurchargesApplication(props) {
  const history = useHistory();
  const farmCTX = useContext(FarmContext);
  const accordionCTX = useContext(AccordionFormContext);
  const [directPayments, setDirectPayments] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState([]);
  const [directPaymentIDForConfirmation, setDirectPaymentIDForConfirmation] =
    useState(0);
  const [openNewDirectPaymentWindow, setOpenNewDirectPaymentWindow] =
    useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  useEffect(() => {
    setIsLoadingData(true);
    getDirectPaymentsFromAPI();
    setIsLoadingData(false);
    // eslint-disable-next-line
  }, [farmCTX.farmID]);

  const getDirectPaymentsFromAPI = () => {
    if (farmCTX.farmID)
      directPayment
        .simple(farmCTX.farmID)
        .then((result) => {
          if (result.status === 403) {
            history.push('/login');
          }
          setDirectPayments(result.data);
        })
        .catch(() => {});
  };

  const handleChooseDirectPaymentClick = async (id) => {
    await getChosenDirectPayment(id);
    accordionCTX.changeNavigation('UNLOCK', 'panel4');
  };

  const getChosenDirectPayment = async (id) => {
    await directPayment
      .one(id, farmCTX.farmID)
      .then((result) => {
        if (result.status === 403) {
          history.push('/login');
        }
        accordionCTX.changeFormValue('directPaymentId', result.data.id);
        accordionCTX.changeFormValue('farmID', farmCTX.farmID);
        accordionCTX.changeFormValue('name', result.data.name);
        accordionCTX.changeFormValue('surname', result.data.surname);
        accordionCTX.changeFormValue('pesel', result.data.pesel);
        accordionCTX.changeFormValue('directPaymentYear', result.data.year);
        accordionCTX.changeFormValue(
          'directPaymentIncome',
          result.data.productionValue
        );
        accordionCTX.changeFormValue(
          'directPaymentIdentification',
          result.data.confirmationNumber
        );
      })
      .catch(() => {});
  };

  const handleConfirmDialogClose = (dialogOpen) => {
    setConfirmationDialogOpen(dialogOpen);
    setIsLoadingData(true);
    getDirectPaymentsFromAPI();
    setIsLoadingData(false);
  };

  const handleNewPaymentDialogClose = (dialogOpen) => {
    setOpenNewDirectPaymentWindow(dialogOpen);
    setIsLoadingData(true);
    getDirectPaymentsFromAPI();
    setIsLoadingData(false);
  };

  return (
    <>
      <Accordion
        square
        expanded={accordionCTX.navigation.expanded === 'panel3'}
        onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel3')}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <h1>3. Wniosek o dopłaty</h1>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container justifyContent="center" alignItems="center">
            <Grid
              infoCard
              topMargin
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
              component={Paper}
              sx={{ py: 2 }}
            >
              <Typography variant="h4">
                Wybierz gospodarstwo, z którego chcesz złożyć wniosek kredytowy
              </Typography>
            </Grid>
            <Grid item sx={{ my: 4, minWidth: 500 }}>
              <SimpleFarmSelect />
            </Grid>
            <Grid
              infoCard
              topMargin
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
              component={Paper}
              sx={{ py: 1 }}
            >
              <Typography variant="h4">
                Wybierz wniosek o dopłaty bezpośrednie, na podstawie którego
                chciałbyś złożyć wniosek kredytowy
              </Typography>
            </Grid>
            <Grid
              infoCard
              topMargin
              item
              xs={12}
              component={Paper}
              sx={{ py: 2 }}
            >
              <Typography variant="h4" component="div">
                Posiadasz wnioski za lata:
              </Typography>
            </Grid>
            <Grid
              topMargin
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
            >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="collapsible table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Rok</StyledTableCell>
                      <StyledTableCell align="left">Dochód</StyledTableCell>
                      <StyledTableCell align="left">
                        Status potwierdzenia
                      </StyledTableCell>
                      <StyledTableCell align="right" />
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {isLoadingData ? (
                      <StyledTableRow>
                        <StyledTableCell>
                          <DataLoading />
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      <>
                        {directPayments.map((row) => (
                          <StyledTableRow key={row.id}>
                            <StyledTableCell component="th" scope="row">
                              {row.year}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                              {row.productionValue} zł
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                              {row.confirmed ? <CheckIcon /> : <CloseIcon />}
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              align={'right'}
                            >
                              {row.confirmed ? (
                                <Button
                                  onClick={async () => {
                                    await handleChooseDirectPaymentClick(
                                      row.id
                                    );
                                  }}
                                  variant="contained"
                                >
                                  Wybierz wniosek
                                </Button>
                              ) : (
                                <Button
                                  onClick={() => {
                                    setDirectPaymentIDForConfirmation(row.id);
                                    setConfirmationDialogOpen(true);
                                  }}
                                  variant="contained"
                                >
                                  Potwierdź wniosek
                                </Button>
                              )}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid
              infoCard
              topMargin
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
              component={Paper}
              sx={{ py: 1, mt: 4 }}
            >
              <Typography variant="h4">
                Jeżeli wśród powyższych nie ma interesującego Cię wniosku,
                możesz dodać go tutaj
              </Typography>
            </Grid>
            <Grid
              topMargin
              container
              justifyContent="center"
              alignItems="center"
            >
              <Button
                variant="contained"
                onClick={() => setOpenNewDirectPaymentWindow(true)}
              >
                Dodaj nowy wniosek o dopłaty bezpośrednie
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <ConfirmationUploadDialog
        open={confirmationDialogOpen}
        handleAction={handleConfirmDialogClose}
        directPaymentID={directPaymentIDForConfirmation}
      />
      <NewDirectPaymentDialog
        open={openNewDirectPaymentWindow}
        handleAction={handleNewPaymentDialogClose}
      />
    </>
  );
}
